export const tuttoWording = {
  fr: {
    addStudyButton: "Ajouter une Etude",
  },

  en: {
    addStudyButton: "Add Study",
  },
};
